module.exports = __webpack_public_path__ + "static/media/lion-transparent.68e7c084.png";